// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Banner_carousel__ug4rt","carouselSlide":"Banner_carouselSlide__6W5cO","CarouselBullets":"Banner_CarouselBullets__thk6m","SlideBanner":"Banner_SlideBanner__A1iM3"};